export default __webpack_public_path__ + "static/media/A60.4b635dd7.png";